export default __webpack_public_path__ + "static/media/townhouses.01661fac.jpg";